import styled from "@emotion/styled"
import { Dialog, Typography } from "@mui/material"
import * as api from "api"
import CloseButton from "common/CloseButton"
import PromotionForm from "components/ServiceCenter/forms/PromotionForm"

const Styled = {
  Wrapper: styled.div`
    padding: 15px;
    text-align: center;
    overflow: auto;
  `,
  TitleWrapper: styled.div`
    padding-bottom: 15px;
    border-bottom: 2px solid ${(p) => p.theme.colors.silver};
  `,
  Title: styled(Typography)``,
  Description: styled(Typography)``,
}

type PromotionDialogProps = {
  onClose: () => void
  benefit?: api.Benefit
}

const PromotionDialog = ({ onClose, benefit }: PromotionDialogProps) => {
  return (
    <Dialog
      open={benefit != null}
      onClose={onClose}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      maxWidth="xs"
    >
      <CloseButton onClick={onClose} />
      <Styled.Wrapper>
        <Styled.TitleWrapper>
          <Styled.Title variant="h2" id="dialog-title">
            {benefit?.subject}
          </Styled.Title>
          <Styled.Description id="dialog-description">
            {benefit?.description}
          </Styled.Description>
        </Styled.TitleWrapper>
        <PromotionForm benefit={benefit} onSubmit={onClose} />
      </Styled.Wrapper>
    </Dialog>
  )
}

export default PromotionDialog
